import { TablePaginationConfig } from "antd";
import { useMemo } from "react";

export const useNoCountPaginationProps = (
  total: number,
  countNum: number = 10,
) => {
  const paginationProps: false | TablePaginationConfig = useMemo(() => {
    return total <= countNum
      ? false
      : {
          size: "small",
          pageSize: countNum,
        };
  }, [total, countNum]);

  return { paginationProps };
};
